import React from 'react'

import styles from './Header.module.css'

export default function Header({ text, children, component, actions }) {
  const Component = component || 'h1'

  return (
    <div className={styles.wrapper}>
      <Component className={styles.header}>{text || children}</Component>
      {actions && <div className={styles.actions}>{actions}</div>}
    </div>
  )
}
